var React = require('react');

function PlaceholderChart (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"translate(3 3)"},[React.createElement("ellipse",{"cx":"102.4","cy":"102.9","fill":"#E1E8EF","fillOpacity":".2","stroke":"#E1E8EF","strokeWidth":"3","rx":"102.4","ry":"102.9","key":0}),React.createElement("ellipse",{"cx":"102.1","cy":"102.4","fill":"#FFF","rx":"85.1","ry":"85.4","key":1})]));
}

PlaceholderChart.defaultProps = {"width":"211","height":"212"};

module.exports = PlaceholderChart;

PlaceholderChart.default = PlaceholderChart;



//////////////////
// WEBPACK FOOTER
// ./src/components/CirclePackingWrapper/placeholderChart.svg
// module id = 848
// module chunks = 0